import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { API_ERROR_MESSAGE } from "@/constants";
import { getStoredMaintenanceMessage } from "@/utils/maintenance-storage";

interface AppState {
  maintenance: {
    active: boolean;
    message: string;
  };
}

const storedMaintenanceMessage = getStoredMaintenanceMessage();

const initialState: AppState = {
  maintenance: {
    active: Boolean(storedMaintenanceMessage),
    message: storedMaintenanceMessage ?? API_ERROR_MESSAGE.MAINTENANCE,
  },
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    showMaintenance: (
      state,
      action: PayloadAction<{ message?: string | null } | undefined>,
    ) => {
      state.maintenance.active = true;
      state.maintenance.message =
        action.payload?.message?.trim() || API_ERROR_MESSAGE.MAINTENANCE;
    },
    clearMaintenance: (state) => {
      state.maintenance.active = false;
      state.maintenance.message = API_ERROR_MESSAGE.MAINTENANCE;
    },
  },
});

export const { clearMaintenance, showMaintenance } = appSlice.actions;

export default appSlice.reducer;
